import { render, staticRenderFns } from "./main.movimientos-inventario.vue?vue&type=template&id=515ce3a0"
import script from "./main.movimientos-inventario.vue?vue&type=script&lang=js"
export * from "./main.movimientos-inventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports